/*============================================================================
  KYMI star cursor
  ---------------------------------------------------------------------------
  A DOM-based replacement for the native star cursor (assets/star-cursor.png).
  The native `cursor:` property can't be animated, so we hide it and follow the
  pointer with a real element instead — letting the star ease its opacity/scale.

  Behaviour:
    - Only runs for a real mouse (pointer: fine) and when motion is allowed.
      Touch / coarse-pointer devices keep their native behaviour untouched.
    - Over the size-star swatches the star softly fades + shrinks so it stops
      fighting the swatch's own hover state.
    - Over text fields it fades out so the native caret stays readable.
  Hotspot is the star's centre (36, 35) — see overrides.css.
============================================================================*/
(function () {
  var fine = window.matchMedia("(pointer: fine)");
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  if (!fine.matches || reduce.matches) return;

  var TEXT_SELECTOR =
    'input:not([type="submit"]):not([type="button"]):not([type="checkbox"]):not([type="radio"]):not([type="range"]),textarea,[contenteditable="true"]';

  var cursor = document.createElement("div");
  cursor.className = "kymi-cursor is-hidden";
  cursor.setAttribute("aria-hidden", "true");

  var star = document.createElement("div");
  star.className = "kymi-cursor__star";
  cursor.appendChild(star);

  var mounted = false;
  var x = 0;
  var y = 0;
  var rafId = null;

  function mount() {
    if (mounted) return;
    (document.body || document.documentElement).appendChild(cursor);
    document.documentElement.classList.add("kymi-cursor-active");
    mounted = true;
  }

  function render() {
    rafId = null;
    cursor.style.transform = "translate3d(" + x + "px," + y + "px,0)";
  }

  function onMove(e) {
    // Ignore synthetic / touch / pen events — only follow a real mouse.
    if (e.pointerType && e.pointerType !== "mouse") return;

    x = e.clientX;
    y = e.clientY;
    if (!mounted) mount();
    cursor.classList.remove("is-hidden");
    if (rafId === null) rafId = requestAnimationFrame(render);

    var target = e.target;
    var overStar = !!(
      target &&
      target.closest &&
      target.closest(".size-stars__label")
    );
    var overText = !!(
      target &&
      target.closest &&
      target.closest(TEXT_SELECTOR)
    );
    cursor.classList.toggle("is-soft", overStar);
    cursor.classList.toggle("is-text", overText);
  }

  function hide() {
    cursor.classList.add("is-hidden");
  }

  document.addEventListener("pointermove", onMove, { passive: true });
  document.addEventListener("pointerdown", function (e) {
    if (e.pointerType && e.pointerType !== "mouse") return;
    cursor.classList.add("is-down");
  });
  document.addEventListener("pointerup", function () {
    cursor.classList.remove("is-down");
  });

  // Tuck the star away when the mouse leaves the window or the tab is hidden.
  document.addEventListener("mouseleave", hide);
  window.addEventListener("blur", hide);
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) hide();
  });
})();
